module.exports = __webpack_public_path__ + "static/media/OpenIcon.9f1e2030.svg";